import React, { useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import useBoardStore from '../store/boardStore';
import Sticker from './Sticker';
import Connector from './Connector';
import Toolbar from './Toolbar';
import './Board.css';

const Board = () => {
  const { boardId } = useParams();
  const svgRef = useRef(null);
  
  const {
    stickers,
    connectors,
    isConnecting,
    connectingFrom,
    selectedConnector,
    connectWebSocket,
    createSticker,
    createConnector,
    setConnecting,
    setSelectedConnector,
    disconnect
  } = useBoardStore();
  
  useEffect(() => {
    if (boardId) {
      connectWebSocket(boardId);
    }
    
    // Cleanup on unmount
    return () => {
      disconnect();
    };
  }, [boardId, connectWebSocket, disconnect]);
  
  const handleDoubleClick = (event) => {
    if (isConnecting) return;
    
    const rect = svgRef.current.getBoundingClientRect();
    const x = event.clientX - rect.left;
    const y = event.clientY - rect.top;
    
    createSticker({ x, y });
  };
  
  const handleStickerClick = (stickerId) => {
    console.log('Board handleStickerClick:', { stickerId, isConnecting, connectingFrom });
    if (isConnecting && connectingFrom && connectingFrom !== stickerId) {
      console.log('Creating connector:', connectingFrom, '->', stickerId);
      createConnector(connectingFrom, stickerId);
      setConnecting(false);
    }
  };
  
  const handleBackgroundClick = (event) => {
    if (event.target === svgRef.current) {
      if (isConnecting) {
        setConnecting(false);
      }
      if (selectedConnector) {
        setSelectedConnector(null);
      }
    }
  };
  
  return (
    <div className="board-container">
      <Toolbar />
      <svg
        ref={svgRef}
        className={`board-canvas ${isConnecting ? 'connecting' : ''}`}
        width="100%"
        height="100%"
        onDoubleClick={handleDoubleClick}
        onClick={handleBackgroundClick}
      >
        <defs>
          <marker
            id="arrowhead"
            markerWidth="10"
            markerHeight="7"
            refX="9"
            refY="3.5"
            orient="auto"
          >
            <polygon
              points="0 0, 10 3.5, 0 7"
              fill="#666"
            />
          </marker>
        </defs>
        
        {/* Render stickers first (behind connectors) */}
        {stickers.map((sticker) => (
          <Sticker
            key={sticker.id}
            sticker={sticker}
            onStickerClick={handleStickerClick}
          />
        ))}
        
        {/* Render connectors on top */}
        {connectors.map((connector) => (
          <Connector
            key={connector.id}
            connector={connector}
            stickers={stickers}
          />
        ))}
      </svg>
    </div>
  );
};

export default Board;
